import { Link } from 'react-router-dom';
import { Sparkles, FileUp, RotateCw, Mail } from 'lucide-react';

const ACTIONS = [
  { to: '/exams/generate', title: 'Generate an exam', body: 'From chapters in minutes', Icon: Sparkles, hot: true },
  { to: '/exams/paper/new', title: 'Upload answer sheets', body: 'Paper exams, auto-marked', Icon: FileUp },
  { to: '/class-performance#cycles', title: 'Start remediation', body: 'Target a weak chapter', Icon: RotateCw },
  { to: '/parents/digest', title: 'Send parent digest', body: 'Weekly update to families', Icon: Mail },
];

export default function QuickActions() {
  return (
    <nav aria-label="Quick actions" className="col-span-12 grid grid-cols-1 gap-[18px] min-[820px]:grid-cols-2 min-[1180px]:grid-cols-4">
      {ACTIONS.map(({ to, title, body, Icon, hot }) => (
        <Link key={to} to={to}
          className="flex min-h-[76px] items-center gap-3.5 rounded-[18px] border border-line bg-surface p-4 text-ink no-underline transition hover:-translate-y-0.5 hover:text-ink hover:shadow-card-hover dark:shadow-card">
          <span className={`grid h-11 w-11 flex-none place-items-center rounded-[14px] ${hot ? 'bg-accent text-navy' : 'bg-mist text-slate-ink'}`}>
            <Icon size={22} strokeWidth={1.8} aria-hidden />
          </span>
          <span><span className="block font-semibold">{title}</span><span className="text-[13px] text-muted">{body}</span></span>
        </Link>
      ))}
    </nav>
  );
}
